import { render, staticRenderFns } from "./ensureRuleModel.vue?vue&type=template&id=37678d8c&scoped=true&"
import script from "./ensureRuleModel.vue?vue&type=script&lang=js&"
export * from "./ensureRuleModel.vue?vue&type=script&lang=js&"
import style0 from "./ensureRuleModel.vue?vue&type=style&index=0&id=37678d8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37678d8c",
  null
  
)

export default component.exports